export default {
      id: "stripe-usage",
      viewBox: "0 0 468 222.5",
      url: __webpack_public_path__ + "icons-sprite.396b316.svg#stripe-usage",
      toString: function () {
        return this.url;
      }
    }